/** @format */

import { Vue, Component } from 'vue-property-decorator';

@Component
export default class viewModelDebug extends Vue {
  log() {}

  isLocalDebugMode() {}
  mounted() {}
}
